// extracted by mini-css-extract-plugin
export var box = "_3q-2";
export var checkboxControl = "_3q-0";
export var checkboxRow = "_3q-a";
export var checked = "_3q-3";
export var descriptionSpacer = "_3q-c";
export var disabled = "_3q-4";
export var icon = "_3q-8";
export var input = "_3q-1";
export var labelSpacer = "_3q-b";
export var large = "_3q-7";
export var medium = "_3q-6";
export var small = "_3q-5";
export var text = "_3q-9";